/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type BeginResponseBody = {
  /**
   * Slack authorization URL bound to the current session.
   */
  authorizationUrl: string;
};

/** @internal */
export const BeginResponseBody$inboundSchema: z.ZodMiniType<
  BeginResponseBody,
  unknown
> = z.pipe(
  z.object({
    authorization_url: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "authorization_url": "authorizationUrl",
    });
  }),
);

export function beginResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<BeginResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BeginResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BeginResponseBody' from JSON`,
  );
}
